<script>
import Header from '@/pages/layouts/partials/header.vue'
import Sidebar from '@/pages/layouts/partials/sidebar.vue'
import {Head} from "@inertiajs/vue3";
import custom from "@/externals/custom";
import DynamicHeight from "@/base/DynamicHeight";
import DynamicWidth from "@/base/DynamicWidth";

export default {
  components: {
    Head,
    Header,
    Sidebar
  },
  props: {
    title: String,
  },
  mounted() {
    let params = new URLSearchParams(window.location.search);

    ['success', 'warning', 'info', 'error', 'danger'].forEach((key) => {
      if (params.has(key)) {
        let level = key === 'error' ? 'danger' : key;
        Helpers.Message.flash(params.get(key), level);
      }
    });

    this.$nextTick(() => {
      custom();

      new DynamicWidth({
        scope: '[data-title-bar-wrapper]',
        name: 'title-bar-width',
        callback: () => {
          new DynamicHeight({
            scope: '[data-title-bar]',
            name: 'title-bar-height',
          });
        }
      });
    });
  },
}
</script>

<template>
  <Head :title="title"/>

  <div id="main-wrapper">
    <Header/>

    <Sidebar/>

    <div class="page-wrapper">
      <div class="position-relative" data-title-bar-wrapper>
        <div class="bg-white py-3 mb-4 shadow d-flex flex-column" data-title-bar style="position: fixed; width: var(--title-bar-width, 1850px)">
          <div class="container-fluid flex-grow-1 d-flex flex-column">
            <div class="d-flex flex-column flex-sm-row flex-wrap align-items-sm-center flex-grow-1">
              <div>
                <h1 class="text-themecolor m-0 fs-4">{{ title }}</h1>
              </div>

              <div v-if="$slots.topButtons" class="text-sm-end ms-sm-auto pt-2 pt-sm-0 ps-sm-3">
                <div class="d-flex justify-content-sm-end align-items-sm-center">
                  <slot name="topButtons"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="title-bar-placeholder" style="height: calc(var(--title-bar-height, 53.6px) + 24px) "></div>

      <div class="container-fluid">
        <slot/>
      </div>

      <div v-if="$slots.bottomButtons" class="fixed-bottom-bar">
        <div class="bottom-bar-placeholder"></div>
        <div class="bottom-bar-content d-flex align-items-center shadow">
          <div class="container-fluid">
            <div class="d-flex">
              <slot name="bottomButtons"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div data-message-container class="toast-container top-0 end-0 p-2 p-lg-4 position-fixed message-wrapper"></div>
  <div data-alert-container style="z-index:10"></div>
</template>